import React, { FC } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import WizardContent from '~/layouts/WizardContent';
import { SubmitStageImg } from '~/img';
import features from '~/constants/features';
import { useGetApplication } from '~/controllers/wizard';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import theme from '~/constants/theme';
import DownloadContract from './DownloadContract';

const SubmitStage: FC = () => {
  const { t } = useTranslation('stageResult');
  const applicationQuery = useGetApplication();
  const salesforceApplicationNumber =
    applicationQuery.data?.payload.salesforceApplicationNumber || new Array(11).fill('_').join('');

  return (
    <WizardContent
      content={
        <Container className="SubmitStage">
          <div className="SubmitStage-Content">
            <SubmitStageImg className="SubmitStage-Img" />
            <h3 className="SubmitStage-Title">
              {t('Your application {{salesforceApplicationNumber}} is under review', {
                salesforceApplicationNumber,
              })}
            </h3>
            <Typography.Paragraph className="SubmitStage-Paragraph">
              <p>
                {t('We aim to review your application and we will notify you once your application has been approved.')}
              </p>
              <p>
                <Trans t={t} i18nKey="If you require any support whilst you wait, please <1>contact us</1>.">
                  If you require any support whilst you wait, please
                  <a href={features.contactUsLinkSubmit} target="__blank">
                    contact us
                  </a>
                  .
                </Trans>
              </p>
            </Typography.Paragraph>
            <div className="SubmitStage-DownloadContractBtn">
              <DownloadContract />
            </div>
          </div>
          <div className="SubmitStage-ContactUs">
            <BottomLeftActions contactUsUrl={features.contactUsLinkSubmit} contactUsTextPosition="left" />
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .SubmitStage-Content {
    position: relative;
    .SubmitStage-Img {
      width: 100%;
      margin-bottom: 32px;
    }
    .SubmitStage-Title {
      position: absolute;
      top: 15%;
      left: 5%;
      width: 40%;
      color: #0060a8;
    }
    .SubmitStage-Paragraph {
      margin-left: 5%;
    }
    .SubmitStage-DownloadContractBtn {
      margin-top: 32px;
      margin-left: 5%;
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .SubmitStage-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SubmitStage-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SubmitStage-Paragraph {
        margin-left: 0;
      }
      .SubmitStage-DownloadContractBtn {
        margin-left: 0;
      }
    }
  }
  .SubmitStage-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .SubmitStage-ContactUs {
      display: none;
    }
  }
  @media (max-width: ${theme.breakpoints.sm}px) {
    .SubmitStage-Content {
      .SubmitStage-DownloadContractBtn {
        button {
          width: 100%;
        }
      }
    }
  }
`;

export default SubmitStage;
